'use client';

import Link from 'next/link';
import BrandLogo from '@/components/brand-logo';
import { useContent } from '@/hooks/use-content';

export default function SiteFooter() {
  const c = useContent();
  const { footer } = c;

  return (
    <footer className="bg-[var(--bm-charcoal)] text-white border-t border-[var(--bm-slate)]">
      <div className="bm-container bm-section !py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          <div className="text-start">
            <BrandLogo variant="dark" size="lg" className="mb-5" />
            <p className="text-sm text-white/55 leading-relaxed max-w-sm mt-5">{footer.aboutDescription}</p>
          </div>

          <div className="text-start">
            <p className="bm-eyebrow mb-4 !text-white/35">{footer.aboutTitle}</p>
            <div className="space-y-3 text-sm">
              {footer.quickLinks.map((link) => (
                <Link key={link.href} href={link.href} className="block text-white/65 hover:text-white transition-colors">
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div className="text-start">
            <p className="bm-eyebrow mb-4 !text-white/35">{footer.legalTitle}</p>
            <div className="space-y-3 text-sm">
              {footer.links.map((link) => (
                <Link key={link.label} href={link.href} className="block text-white/65 hover:text-white transition-colors">
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/8">
          <p className="text-xs text-white/40 text-center md:text-end">{footer.copyright}</p>
        </div>
      </div>
    </footer>
  );
}
